import "babel-polyfill";
import "bootstrap/dist/css/bootstrap.min.css";
import { createBrowserHistory } from "history";
import "isomorphic-fetch";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { ScrollToTopWithRouter } from "src/components/ScrollToTop";
import configureStore from "src/configureStore";
import App from "src/containers/App";
import "src/style/index.scss";

const history = createBrowserHistory();

const store = configureStore(history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTopWithRouter>
        <App />
      </ScrollToTopWithRouter>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
